module.exports = __webpack_public_path__ + "img/1551395671.bad8f9e0.jpg";